import { action, observable, runInAction } from 'mobx';
import { ChangeDateForm } from 'application/schedule/forms';
import {BaseEditViewStore} from 'core/stores';
import {applicationContext} from 'core/utils';
import {ScheduleService} from 'application/schedule/services';
import moment from 'moment';

@applicationContext
class ChangeDateModalStore extends BaseEditViewStore {
    @observable accessor pastOrders = [];
    constructor(rootStore, componentProps) {
        const modalParams = componentProps.modalParams;
        const scheduleService = new ScheduleService(rootStore.application.baasic.apiClient)
        super(rootStore, {
            name: 'event',
            id: componentProps.modalParams.data.ids,
            Form: ChangeDateForm,
            FormClass: ChangeDateForm,
        });

        this.modalParams = modalParams;
        this.scheduleService = scheduleService;
        this.form.set({date: moment().format('YYYY-MM-DD')});
    }
    @action.bound
    async getResource(id, updateForm = true) {
        runInAction(() => {
            if (updateForm) {
                this.updateForm();
            }
        });
    }
    @action.bound
    async updateResource(resource) {
        this.form.setFieldsDisabled(true);
        try {
            await this.scheduleService.updateDates({ids: this.modalParams.data.ids, date: resource.date});

            this.form.setFieldsDisabled(false);
            this.modalParams.close();   
            this.modalParams.data.fetchTable();
            this.rootStore.notificationStore.success("Changes successfully saved.");
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error("Error occured while saving.");
        }
    }

}

export default ChangeDateModalStore;
